/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
const clone = require('./src/clone');
const convert = require('./src/convert');
const jsonpath = require('./src/jsonpath');
const looppath = require('./src/looppath');
// const file = require('./src/file');
const functions = require('./src/functions');
const isDeepEqual = require('./src/isDeepEqual');
const isType = require('./src/isType');
const memoize = require('./src/memoize');
const mqtt = require('./src/mqtt');
// const plugins = require('./src/plugins');
const proc = require('./src/proc');
const promise = require('./src/promise');
const requireFile = require('./src/requireFile');
const serialnumber = require('./src/serialnumber');
const sheetrange = require('./src/sheetrange');
const sleep = require('./src/sleep');
// const moduleResolver = require('./src/moduleResolver');

module.exports = {
	clone,
	convert,
	jsonpath,
	looppath,
	// file,
	functions,
	isDeepEqual,
	isType,
	memoize,
	mqtt,
	// plugins,
	proc,
	promise,
	requireFile,
	serialnumber,
	sheetrange,
	sleep
	// moduleResolver
};
